import { usePageTitleAndDesc } from "@ugg/shared/utils/seo-helpers";
import { PrivacyPolicyText } from "@ugitgud/legos/components/content/PrivacyPolicyText";

const PrivacyPolicyPage = () => {
  const getPageTitleAndDesc = usePageTitleAndDesc();

  return (
    <div className="privacy-policy-page">
      <div className="text-content-container content-side-padding">
        {getPageTitleAndDesc("privacy_policy")}
        <div className="text-content">
          <PrivacyPolicyText title="ProBuild Stats Privacy Policy" />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
